/**
 * SimilarTracks Component
 */

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import { QueryStringContext } from '../../../../contexts/queryString';
import { ArtistPagePath } from '../../../pages/Artist';
import { TrackListQuery } from '../../search/TrackList';

interface ISimilarTracksProps {
  artistSlug: string;
  className: string;
  licenseParams?: GQL.ILicenseUsageParamsInput[] | undefined;
  trackId: string;
}

interface ISimilarTracksState {
  hasSimilarTracks: boolean;
}

const classes = new BEM('similar-tracks');

class SimilarTracksBase extends React.Component<ISimilarTracksProps, ISimilarTracksState> {
  artistPagePath: string;

  constructor(props: ISimilarTracksProps) {
    super(props);

    this.artistPagePath = ArtistPagePath(props.artistSlug);

    this.state = {
      hasSimilarTracks: true,
    };
  }

  componentDidUpdate(prevProps: ISimilarTracksProps, prevState: ISimilarTracksState) {
    if (this.props.artistSlug !== prevProps.artistSlug) {
      this.setState({ hasSimilarTracks: true });
    }
  }

  onTrackListResult = (results: GQL.ITrackSearchResult[]) => {
    if (!results || results.length === 0) {
      this.setState({ hasSimilarTracks: false });
    } else if (this.state.hasSimilarTracks === false) {
      this.setState({ hasSimilarTracks: true });
    }
  }

  render() {
    return this.state.hasSimilarTracks && location.pathname !== this.artistPagePath ? (
      <div {...classes('', '', this.props.className)} data-title="More like this">
        <TrackListQuery
          actionSource="track_details_list"
          cardProps={{
            backgroundColor: 'white',
            size: 'xsmall',
            options: ['PriceElement', 'AddToProject', 'ShowDetails'],
          }}
          excludeSearchResults={[]}
          searchQuery={{
            count: 5,
            filters: {
              similarity: {
                track_id: this.props.trackId,
                feature: GQL.TrackSimilarityFeature.Default,
              },
            },
            license_params: this.props.licenseParams,
          }}
          // IMPORTANT: We don't want tracks from the details panel to keep getting added to the queue
          // any time it's opened. Each track will be added when its play button is clicked instead.
          shouldAddTracksToQueue={false}
          onResult={this.onTrackListResult}
          {...classes('list')}
        />
      </div>
    ) : null;
  }
}

export const SimilarTracks: React.SFC<ISimilarTracksProps> = (props) => (
  <QueryStringContext.Consumer>
    {({ license_params }) => (
      <SimilarTracksBase
        licenseParams={license_params}
        {...props}
      />
    )}
  </QueryStringContext.Consumer>
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/modals/TrackDetails/SimilarTracks.tsx